import { createApi } from '@reduxjs/toolkit/query/react';
import rtkFetchRequest from '../configs/rtkFetchRequest';

export const subscriptionsApi = createApi({
  reducerPath: 'subscriptions',
  baseQuery: rtkFetchRequest(),
  endpoints: (builder) => ({
    getListSubscriptions: builder.query({
      query: (query) => ({
        method: 'GET',
        endpoint: `/subscriptions`,
        body: query,
      }),
    }),
    getSubscriptionReactivationCost: builder.query({
      query: (id) => ({
        method: 'GET',
        endpoint: `/subscriptions/${id}/reactivation_cost`,
      }),
    }),
    // getReactivationStatus: builder.query({
    //   query: (id) => ({
    //     method: 'GET',
    //     endpoint: `/subscriptions/${id}/reactivation_status`,
    //   }),
    // }),
    // updateActivateSubscription: builder.mutation({
    //   query: ({ id, query, ...params }) => ({
    //     sdkRequest: updateSubscription,
    //     id,
    //     query,
    //     params,
    //   }),
    // }),
  }),
});

export const {
  useGetListSubscriptionsQuery,
  useGetSubscriptionReactivationCostQuery,
} = subscriptionsApi;
